import { ComponentProps, FC } from 'react';

import { SvgIcon } from './SvgIcon';

export const Download: FC<ComponentProps<typeof SvgIcon>> = props => (
  <SvgIcon width="25" height="24" viewBox="0 0 25 24" {...props}>
    <path d="M5.81616 20.5H19.8162V18.5H5.81616V20.5ZM19.8162 9.5H15.8162V3.5H9.81616V9.5H5.81616L12.8162 16.5L19.8162 9.5Z" />
  </SvgIcon>
);
